import React from 'react';
import Create from './pages/Create';
import Edit from './pages/Edit';
import Index from './pages/Index';
import { AppRouteProps } from '~/routes';

export default function VehicleRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/vehicle', component: Index, isProtected: true, permissions: ['vehicle_index']},
    {path: '/vehicle/create', component: Create, isProtected: true, permissions: ['vehicle_create']},
    {path: '/vehicle/edit/:id', component: Edit, isProtected: true, permissions: ['vehicle_edit']},
  ];

  return routes;
}
